import { forwardRef } from 'react'

import * as Switch from '@radix-ui/react-switch'
import { DISPLAY_NAME, useSwitchContext } from '../../switch'

import type { SwitchScopedProps } from '../../switch.types'

import { SwitchToggleVariants } from './switch-toggle.styles'

type SwitchToggleProps = Switch.SwitchProps & {
  children: React.ReactNode
}

export const SwitchToggle = forwardRef<
  React.ElementRef<typeof Switch.Root>,
  SwitchToggleProps
>((props, ref) => {
  const { children, __scopeSwitch } =
    props as SwitchScopedProps<SwitchToggleProps>
  const {
    disabled: isDisabled,
    loading: isLoading,
    defaultChecked,
    checked,
    ...rest
  } = useSwitchContext(DISPLAY_NAME, __scopeSwitch)
  return (
    <Switch.Root
      {...rest}
      ref={ref}
      defaultChecked={defaultChecked}
      checked={checked}
      data-testid="switch-toggle"
      disabled={isDisabled || isLoading}
      className={SwitchToggleVariants({
        isDisabled,
        isLoading,
      })}
    >
      {children}
    </Switch.Root>
  )
})

SwitchToggle.displayName = 'SwitchToggle'
